// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"c6d3e39cd2ff97d06e0b","293":"6c060dec139765417d6a"}[chunkId] + ".js";
};